export const MESSAGE_TEMPLATE_QUERY_KEY = "message-template";
